export const step7Styles = {
  width: "100%",
  boxSizing: "border-box",
  padding: "0 2rem 1rem 2rem",
  "& .step7-title": {
    color: "#8f8f8f",
    fontWeight: 500,
    letterSpacing: "0.2px",
    textAlign: "left",
  },
  "& .step7-meta-compact": {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    padding: "10px 14px",
    border: "1px solid #ececec",
    borderRadius: "8px",
    background: "#fafafa",
    maxWidth: "520px",
    marginTop: "10px",
  },
  "& .step7-meta-line": {
    display: "flex",
    gap: "24px",
  },
  "& .step7-meta-line > div": {
    display: "flex",
    flexDirection: "column",
    minWidth: "160px",
  },
  "& .step7-meta-label": {
    fontSize: "10.5px",
    fontWeight: 600,
    color: "#b4b4b4",
    letterSpacing: "0.4px",
    textTransform: "uppercase",
  },
  "& .step7-meta-value": {
    fontSize: "12px",
    fontWeight: 500,
    color: "#2f55d4",
    lineHeight: 1.3,
  },
  "& .step7-table.MuiPaper-root": {
    border: "1px solid #d6d6d6",
    borderRadius: "6px",
    boxShadow: "none",
    overflow: "auto",
  },
  "& .step7-table-inner": {
    minWidth: "980px",
  },
  "& .step7-thead .step7-th.MuiTableCell-root": {
    background: "#9f9f9f",
    color: "#ffffff",
    fontWeight: 700,
    borderBottom: "1px solid #d6d6d6",
    padding: "10px 12px",
    whiteSpace: "nowrap",
  },
  "& .step7-td.MuiTableCell-root": {
    color: "#565656",
    borderBottom: "1px solid #ececec",
    padding: "14px 12px",
    // !important: sesion-search.css fija "font-size" en todas las tablas de la app
    fontSize: "14px !important",
    lineHeight: 1.35,
    verticalAlign: "middle",
  },
  "& .step7-td-nro": {
    width: "90px",
    textAlign: "center",
    fontWeight: 700,
    color: "#2f55d4",
  },
  "& .step7-td-tema": {
    maxWidth: "240px",
    wordBreak: "break-word",
  },
  "& .step7-td-desc": {
    maxWidth: "420px",
  },
  "& .step7-desc-preview": {
    display: "-webkit-box",
    WebkitLineClamp: 3,
    fontSize: 14,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    color: "#6a6a6a",
    lineHeight: 1.4,
  },
  "& .step7-tr": {
    transition: "background 0.15s ease",
  },
  "& .step7-tr:hover": {
    background: "#fafafa",
  },
  "& .step7-actions-wrapper": {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "center",
  },
  "& .step7-action-inline.MuiButton-root": {
    padding: "8px 16px",
    minWidth: "160px",
    height: "40px",
    fontSize: "13px",
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "none",
    color: "#ffffff",
    background: "#3f6ed8",
    borderRadius: "10px",
    justifyContent: "center",
  },
  "& .step7-action-inline.MuiButton-root:hover": {
    background: "#345fc0",
  },
  "& .step7-action-inline.Mui-disabled": {
    opacity: 1,
    pointerEvents: "none",
    background: "#d7d7d7",
    color: "#ffffff",
  },
  "& .step7-footer": {
    display: "flex",
    justifyContent: "flex-start",
  },
  "& .step7-btn.MuiButton-root": {
    borderRadius: "999px",
    height: "42px",
    padding: "0 18px",
    fontWeight: 800,
    letterSpacing: "0.6px",
    textTransform: "uppercase",
    boxShadow: "none",
    fontSize: "12px",
  },
  "& .step7-btn-back.MuiButton-outlined": {
    border: "2px solid #00c7db",
    color: "#00c7db",
    background: "transparent",
  },
  "& .step7-btn-back.MuiButton-outlined:hover": {
    borderColor: "#00a9b9",
    color: "#00a9b9",
    background: "rgba(0, 199, 219, 0.08)",
  },
  "& .step7-btn-download.MuiButton-contained": {
    background: "#00c7db",
    color: "#fff",
  },
  "& .step7-btn-download.MuiButton-contained:hover": {
    background: "#00a9b9",
  },
  "& .step7-btn-download.MuiButton-contained.Mui-disabled": {
    background: "#d7d7d7",
    color: "#ffffff",
    opacity: 1,
  },
  "& .step7-btn-back.MuiButton-outlined.Mui-disabled": {
    borderColor: "#cfcfcf",
    color: "#bdbdbd",
    opacity: 1,
  },
  "& .step7-dialog .MuiPaper-root": {
    borderRadius: "14px",
  },
  "@media (max-width:900px)": {
    "& .step7-table-inner": {
      minWidth: "900px",
    },
  },
  "@media (max-width:780px)": {
    "& .step7-dl-wrap, & .step7-dl-wrap .MuiButton-root, & .step7-btn-close.MuiButton-root": {
      width: "100%",
    },
  },
  "@media (max-width:600px)": {
    padding: "0 1rem 1rem 1rem",
    "& .step7-title": {
      fontSize: "28px",
    },
    "& .step7-footer": {
      justifyContent: "stretch",
    },
    "& .step7-btn.MuiButton-root": {
      width: "100%",
      minWidth: "100%",
    },
    "& .step7-meta-line": {
      flexDirection: "column",
      gap: "4px",
    },
  },
};
